import { Alert } from '@factorialco/deprecated-design-system'
import { PayrollDetailsIncidenceViewFragment } from 'generated/resources/graphql'

import BasicView from './BasicView'
import DetailedView from './DetailedView'

interface Props {
  employeeId: string
  basicView?: boolean
  ruleEvaluation: PayrollDetailsIncidenceViewFragment
}

const IncidenceRuleAlert = ({ employeeId, basicView = true, ruleEvaluation }: Props) => {
  return (
    <Alert color="warning">
      {basicView ? (
        <BasicView ruleEvaluation={ruleEvaluation} />
      ) : (
        <DetailedView ruleEvaluation={ruleEvaluation} employeeId={employeeId} />
      )}
    </Alert>
  )
}

export default IncidenceRuleAlert
